<template>
    <div class="c-header-menu" :id="btnId">
        <button class="btn" @click.prevent="toggleMenu"></button>

        <div class="menu" v-if="menuVisible">
            <button class="menu--item menu--item--arrow"
            @click.prevent="showSalesList"
                v-on:mouseover="showSalesList"
                v-on:mouseout="hideSalesList">
                    {{$t('sales_select.change_sales')}}
            </button>
            <button class="menu--item" @click.prevent="showCreateNewSales" v-if="isSalesAdmin">{{$t('sales_select.edit_sales')}}</button>
            <button class="menu--item" @click.prevent="showSettings" v-if="isSalesAdmin">{{$t('sales_select.shop_settings')}}</button>
            <button class="menu--item" @click.prevent="showAccountSettings">{{$t('sales_select.account_settings')}}</button>
            <button class="menu--item" @click.prevent="logout">{{$t('login.logout')}}</button>
        </div>

        <div class="sales-list" v-if="salesList" v-on:mouseover="showSalesList">
            <div class="sales-list--item" :class="{active: sale.id == loggedInSales.id}"  v-for="sale in sales" :key="sale.id" @click.prevent="selectSales(sale)">
                {{sale.firstname}} {{sale.lastname}}
            </div>
        </div>
    </div>
</template>

<script>
import DocumentClickMixin from "@/mixins/DocumentClickMixin";
import LoginMixin from "@/mixins/LoginMixin";
import {apiStore} from "@/stores/api.js";
import {measurementStore} from "@/stores/measurement";

export default {
    name : "HeaderMenu",
    mixins: [DocumentClickMixin, LoginMixin],

    data() {
        return {
            btnId : "header-menu",
            menuVisible: false,
            salesList: false,
            sales: []
        };
    },

    async created() {
        this.sales = await apiStore().getSalesForShop();
    },

    methods: {
        toggleMenu() {
            this.menuVisible = !this.menuVisible;
            this.salesList = false;
        },

        showSettings() {
            this.menuVisible = false;
            this.salesList = false;
            if (this.$router.currentRoute.name !== "shop-settings") {
                this.$router.push({name : "shop-settings"});
            }
        },

        showSalesList() {
            clearTimeout(this.timeout);
            this.salesList = true;
        },

        hideSalesList() {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.salesList = false;
            }, 100);
        },

        showCreateNewSales() {
            this.menuVisible = false;
            this.salesList = false;
            if (this.$router.currentRoute.name !== "sales-admin") {
                this.$router.push({name : "sales-admin"});
            }
        },

        showAccountSettings() {
            this.menuVisible = false;
            this.salesList = false;
            if (this.$router.currentRoute.name !== "account-settings") {
                this.$router.push({name : "account-settings"});
            }
        },

        logout() {
            this.menuVisible = false;
            this.salesList = false;
            measurementStore().measurementDate = undefined;
            this.$emit("logout");
        },

        selectSales(sale) {
            this.menuVisible = false;
            this.salesList = false;
            apiStore().setLoggedInSales(sale);

            setTimeout(() => {
                if (this.$router.currentRoute.name === "appointment-list") {
                    this.$router.go();
                } else {
                    this.$router.replace({name : "appointment-list"});
                }
            }, 500);
        },

        documentClickTriggered(e) {
            const parent = e.target.closest("#header-menu");

            if (parent === null && this.menuVisible) {
                this.salesList = false;
                this.menuVisible = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-header-menu {
        font-weight: normal;
        position: relative;

        .btn {
            @extend .reset-btn;
            background-image : url('/img/arrow-show-menu.svg');
            background-repeat : no-repeat;
            background-size: 65%;
            background-position: center;
            width: 2.25rem;
            height: 2.25rem;
            margin-right: 0.5rem;
            position: relative;
            border: solid .05rem #777;
            border-radius: 50%;
            outline: none;
        }

        .menu {
            position: absolute;
            z-index: 50;
            top: 2.8rem;
            left: -0.2rem;
            width: 20rem;
            box-shadow: 0px 4px 6px 1px rgba(0,0,0,0.15), 0px -4px 6px 1px rgba(0,0,0,0.15);

            &--item {
                padding : .7rem 1.5rem;
                font-size: 1.15em;
                display: flex;
                background : white;
                width : 100%;
                border : none;
                outline : none;
                position: relative;
                text-align: left;

                &:hover {
                    cursor : pointer;
                    background-color : #f3f3f3;
                }

                &:not(:first-child) {
                    border-top: solid 1px #aaaaaa;
                }

                &--arrow:after {
                    content: ' ';
                    background-image : url('/img/arrow-show-menu-right.svg');
                    background-repeat : no-repeat;
                    background-size: 65%;
                    background-position: center;
                    width: 2.25rem;
                    height: 2.25rem;
                    position: absolute;
                    right: 0;
                    top: 0.1em;
                }

            }

            &:before {
                $triangle : .8rem;
                position: absolute;
                content: ' ';
                width: 0;
                height: 0;
                left : .75rem;
                top : #{-$triangle};
                border-left: math.div($triangle, 1.25) solid transparent;
                border-right: math.div($triangle, 1.25) solid transparent;
                border-bottom: $triangle solid #fff;
            }
        }

        .sales-list {
            position: absolute;
            z-index: 50;
            top: 2.8rem;
            left: 19.8rem;
            width: 20rem;
            box-shadow: 0px 4px 6px 1px rgba(0,0,0,0.15), 0px -4px 6px 1px rgba(0,0,0,0.15);
            z-index: 2;

            &--item {
                padding : .7rem 1.5rem;
                font-size: 1.15em;
                display: flex;
                background : white;
                width : 100%;
                border : none;
                outline : none;

                &.active {
                    font-weight: bold;
                }

                &:hover {
                    cursor : pointer;
                    background-color : #f3f3f3;
                }

                &:not(:first-child) {
                    border-top: solid 1px #aaaaaa;
                }
            }
        }
    }

</style>